import {
  CurrenciesListListData,
  currenciesListListInfiniteOptions,
  Dropdown,
  PaginatedDropdownList
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { useDefaultCurrency } from '@crm/hooks/useDefaultCurrency'
import { useLocales } from '@shared/locales'
import { Button, Col, Divider, Flex, Form, Input, Row, Typography } from 'antd'
import { Add, Trash } from 'iconsax-react'

export const SettingsDynamicFields = () => {
  const { t } = useLocales()
  const { defaultCurrency } = useDefaultCurrency()

  return (
    <Form.List
      name="bank_accounts"
      initialValue={[
        {
          account_name: null,
          bank_name: null,
          bank_iban: null,
          swift: null,
          bank_address: null,
          currency: defaultCurrency
        }
      ]}
    >
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name }) => (
            <Row key={key} gutter={12}>
              <Divider />

              <Flex
                gap={4}
                className="w-full"
                justify="space-between"
                style={{ paddingInline: 6 }}
              >
                <Typography.Title level={5}>
                  Account #{key + 1}
                </Typography.Title>
                <Button
                  onClick={() => remove(name)}
                  icon={<Trash size={20} color="red" />}
                />
              </Flex>

              <Col span={12}>
                <Form.Item
                  label={t(`billing.account_name`)}
                  name={[name, 'account_name']}
                >
                  <Input placeholder={t(`billing.account_name`)} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={t(`billing.bank_name`)}
                  name={[name, 'bank_name']}
                >
                  <Input placeholder={t(`billing.bank_name`)} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={t(`billing.bank_iban`)}
                  name={[name, 'bank_iban']}
                >
                  <Input placeholder={t(`billing.bank_iban`)} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label={t(`billing.swift`)} name={[name, 'swift']}>
                  <Input placeholder={t(`billing.swift`)} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={t(`billing.bank_address`)}
                  name={[name, 'bank_address']}
                >
                  <Input placeholder={t(`billing.bank_address`)} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={t(`billing.currency`)}
                  name={[name, 'currency']}
                >
                  <InfiniteSelect<
                    CurrenciesListListData,
                    PaginatedDropdownList,
                    Dropdown
                  >
                    popupMatchSelectWidth
                    placeholder={t('billing.currency')}
                    getQueryFunction={currenciesListListInfiniteOptions}
                  />
                </Form.Item>
              </Col>
            </Row>
          ))}

          <Button
            onClick={() =>
              add({
                account_name: null,
                bank_name: null,
                bank_iban: null,
                swift: null,
                bank_address: null,
                currency: defaultCurrency
              })
            }
            icon={<Add size={20} />}
          >
            {t('buttons.add')}
          </Button>
        </>
      )}
    </Form.List>
  )
}
